/* From the Archives: decade filter chips + lightbox flip-through. Loaded by sections/archive-gallery.liquid. */
(function () {
  'use strict';

  var doc = document;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); };

  function initGallery(root) {
    $$('[data-archive-gallery]', root).forEach(function (section) {
      if (section.dataset.archiveReady) return;
      section.dataset.archiveReady = '1';

      var items = $$('.archive-gallery__item', section);
      var chips = $$('.archive-gallery__chip', section);
      var dialog = section.querySelector('.archive-gallery__lightbox');

      // Decade filter: undated items always show.
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var decade = chip.dataset.decade;
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          items.forEach(function (li) { li.hidden = !!decade && !!li.dataset.decade && li.dataset.decade !== decade; });
        });
      });

      if (!dialog || typeof dialog.showModal !== 'function') return;
      var img = dialog.querySelector('.archive-gallery__lb-img');
      var yearEl = dialog.querySelector('[data-lb-year]');
      var capEl = dialog.querySelector('[data-lb-caption]');
      var current = -1;

      function visible() {
        return items.filter(function (li) { return !li.hidden; }).map(function (li) { return li.querySelector('.archive-gallery__media'); });
      }
      function show(btn) {
        var list = visible();
        current = list.indexOf(btn);
        if (current < 0) return;
        img.src = btn.dataset.full;
        img.alt = btn.dataset.caption || '';
        yearEl.textContent = btn.dataset.year || '';
        yearEl.hidden = !btn.dataset.year;
        capEl.textContent = btn.dataset.caption || '';
        dialog.querySelector('[data-lb-prev]').hidden = list.length < 2;
        dialog.querySelector('[data-lb-next]').hidden = list.length < 2;
        if (!dialog.open) dialog.showModal();
      }
      function step(delta) {
        var list = visible();
        if (!list.length) return;
        show(list[(current + delta + list.length) % list.length]);
      }

      $$('.archive-gallery__media', section).forEach(function (btn) {
        btn.addEventListener('click', function () { show(btn); });
      });
      dialog.querySelector('[data-lb-close]').addEventListener('click', function () { dialog.close(); });
      dialog.querySelector('[data-lb-prev]').addEventListener('click', function () { step(-1); });
      dialog.querySelector('[data-lb-next]').addEventListener('click', function () { step(1); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); }); // backdrop
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      });
      dialog.addEventListener('close', function () { img.removeAttribute('src'); });
    });
  }

  window.theme.register(function (root) {
    initGallery(root);
  });
})();
